import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaLoyaltyProgramKpi } from 'src/app/assabil-sales/models/dtos/geo-area-loyalty-program-kpi';

@Component({
  selector: 'geo-area-loyalty-program-kpi',
  templateUrl: './geo-area-loyalty-program-kpi.component.html',
  styleUrls: ['./geo-area-loyalty-program-kpi.component.scss']
})
export class GeoAreaLoyaltyProgramKpiComponent implements OnInit {


  @Input() geoAreaLoyaltyProgramKpi : GeoAreaLoyaltyProgramKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaLoyaltyProgramKpi.expanded = !this.geoAreaLoyaltyProgramKpi.expanded;
  }
}